import React from "react";
import UserInformation from "../../../../components/forms/userForms/userInformation/userInformation";
import Job from "../../../../components/forms/userForms/userJob/job";

export default function SecondPageForm() {

  return (
    <>
    <Job />
    <UserInformation />
  </>
  );
}
